// axiosConfig.ts
import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import { AppDispatch } from "../../store"; // Update with your actual store path
import { logout } from "../../features/user/UserSlice";
import { getUserFromStorage } from "../manageStorage";

let dispatch: AppDispatch | undefined;

export const setAxiosDispatch = (fn: AppDispatch): void => {
  dispatch = fn;
};

const customFetch: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

// ======= (adds token automatically) =======
customFetch.interceptors.request.use(
  (config: any) => {
    const token = getUserFromStorage()?.accessToken;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

customFetch.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => response,
  (error: AxiosError): Promise<never> => {
    if (error.response && error.response.status === 401 && dispatch) {
      dispatch(logout());
    }
    return Promise.reject(error);
  }
);

export default customFetch;
